import OrderHistoryTab from './OrderHistoryTab'

export default OrderHistoryTab



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OrderHistoryTab/index.js